import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import HelpBubble from '@helsenorge/designsystem-react/components/HelpBubble';
import SafeHTML from '@helsenorge/framework-utils/components/safe-html';
import HjelpetriggerComponent from './hjelpetrigger-component';
export const HjelpebobleComponent = ({ hjelpetekstId, resources, onChange, onShowMoreClick, visible, triggerData, tjenesteNavn, bubbleText, moreHelpText, }) => {
    const hjelpetriggerRef = React.useRef(null);
    const showMoreButton = triggerData ? triggerData.hasSeksjonText : false;
    const renderBubbleContent = () => {
        return bubbleText ? _jsx(SafeHTML, { html: bubbleText }) : _jsx("span", { children: triggerData?.bobletekst ?? '' });
    };
    const showMoreClickHandler = (event) => {
        event?.stopPropagation();
        if (onShowMoreClick) {
            onShowMoreClick(hjelpetekstId, tjenesteNavn);
        }
    };
    const renderBubble = () => {
        return (_jsx(HelpBubble, { controllerRef: hjelpetriggerRef, linkText: moreHelpText ? moreHelpText : resources?.moreHelp, onLinkClick: showMoreButton ? showMoreClickHandler : undefined, showBubble: visible, closeAriaLabel: resources?.helpBubbleClose, onClose: () => {
                onChange && onChange();
            }, children: renderBubbleContent() }));
    };
    if (!triggerData || !resources) {
        return _jsx("div", {});
    }
    return (_jsxs("span", { children: [_jsx(HjelpetriggerComponent, { ref: hjelpetriggerRef, hjelpetekstId: hjelpetekstId, resources: resources, sporsmalstekst: triggerData.sporsmalstekst, tjenesteNavn: tjenesteNavn, onClick: onChange, helpBubbleIsExpanded: visible }), renderBubble()] }));
};
export default HjelpebobleComponent;
